import * as React from 'react';
import { ThemeProvider } from 'styled-components';
import { AppContext } from '../State';
import extractMerchantReference from '../logic/ExtractMerchantReference';
import loadAppSettings from './util/LoadAppSettings';
import updateFavicon from './util/UpdateFavicon';
import AppContent from './AppContent';

type Props = {
  children: React.ReactNode;
};

type State = {
  ready: boolean;
};

export class AppLayout extends React.Component<Props, State> {
  // eslint-disable-next-line react/static-property-placement
  static contextType = AppContext;

  constructor(props: Props) {
    super(props);
    this.state = {
      ready: false,
    };
  }

  async componentDidMount() {
    const reference = extractMerchantReference(window.location.pathname);
    // @ts-ignore
    this.context.order.setMerchantReference(reference);
    await loadAppSettings(
      reference!,
      // @ts-ignore
      this.context.theme,
      // @ts-ignore
      this.context.config,
      () => this.setState({ ready: true })
    );
    // @ts-ignore
    updateFavicon(this.context.theme.getSettings());
  }

  render() {
    return (
      // @ts-ignore
      <ThemeProvider theme={this.context.theme.getSettings()}>
        <AppContent isReady={this.state.ready}>
          {this.props.children}
        </AppContent>
      </ThemeProvider>
    );
  }
}

export default AppLayout;
